// Legacy code, just modularized

import $ from 'jquery';
import Masonry from 'masonry-layout';

function refreshNewsList(masonryContainer, type, showItems) {
  var start = $('.restaurant-newslist').data('day-start').split('.');
  var end = $('.restaurant-newslist').data('day-end').split('.');

  var startNum = start[2] + start[1] + start[0];
  var endNum = end[2] + end[1] + end[0];

  var showNews = 20;

  if(type === 1) {

    showItems = 20;

    $('.grid-item').each(function(index) {
      if($(this).data('date') > startNum || $(this).data('date') < endNum || showNews <= 0) {
        $(this).hide();
      } else if(showNews > 0) {
        showNews--;
        $(this).show();
      }
    });

  } else {
    showItems = showItems + 20;
    showNews = showItems;

    $('.grid-item').each(function(index) {
      if($(this).data('date') > startNum || $(this).data('date') < endNum || showNews <= 0) {
        $(this).hide();
      } else if(showNews > 0) {
        showNews--;
        $(this).show();
      }
    });

  }

  if(showItems >= $('.grid-item').length) {
    $('.load-more a').hide();
  } else {
    $('.load-more a').show();
  }

  masonryContainer.layout();
  return showItems;
}

function initializeMasonry() {
  var masonryContainer = document.querySelector('#news-masonry');
  var msnry = new Masonry( masonryContainer, {
    itemSelector: '.grid-item',
    columnWidth: '.grid-sizer',
    percentPosition: true
  });

  var show = 20;

  show = refreshNewsList(msnry, 1, show);


  $('input#dayStart').on('change',function() {
    show = refreshNewsList(msnry, 1, show);
  });

  $('input#dayEnd').on('change',function() {
    show = refreshNewsList(msnry, 1, show);
  });

  $('.load-more a').on('click',function(e) {
    e.preventDefault();
    show = refreshNewsList(msnry, 2, show);
  });
}

const newsList = {
  init: function() {
    $(window).on('load', function() {
      if($('#news-masonry').length > 0) {
        initializeMasonry();
      }
    });
  }
};

export default newsList;
